import type { RenderQuality } from './render-quality.policy';

/** `turn` keeps the rig turning, `frame` draws it once in 3D, `still` keeps the pre-rendered picture. */
export type ShowcaseMode = 'turn' | 'frame' | 'still';

/**
 * How the showcase runs here. Only the high tier with motion allowed turns the rig; a modest
 * device, or someone who asked for less motion, gets one 3D frame, which still carries the
 * company's logo; no WebGL keeps the still.
 */
export function showcaseMode(quality: RenderQuality, prefersReducedMotion: boolean): ShowcaseMode {
  if (quality === 'unsupported') return 'still';
  if (quality === 'low' || prefersReducedMotion) return 'frame';
  return 'turn';
}
